export const GRID_TOOLBAR_CONTROL_CLASSNAME = 'h-10'
export const GRID_TOOLBAR_INPUT_CLASSNAME = 'h-10 py-2'
